import React, { Component } from 'react';
import { Link } from 'react-router-dom'

import "./Card.scss"

class Card extends Component {
  render() {
    return (
      <section className={"section section-card " + this.props.data.className}>
        <div className="padding">
          <div className="central">
            { /* 
            <div className="card"></div>
            */
            }
            <div className="readmore">
            <h4>{this.props.data.headline}</h4>
              <h5>{this.props.data.desc}</h5>
              <div className="button">
                <Link to={this.props.data.link}>
                  <div className="label">
                    {this.props.data.button}
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Card;



// WEBPACK FOOTER //
// ./src/components/Card/Card.js